import React, { Component } from "react";
import registerServiceWorker from "../registerServiceWorker";
import "./style/App.css";
import Header from "./header";
import Calendar from "./calendar";
import Gallery from "./imagegallery";
import Videogallery from "./videogallery";
import Main from "./main";
import Jugend from "./jugendarbeit";
import Chronik from "./chronik";
import Freundvereine from "./freundvereine";
import Impressum from "./impressum";
import Footer from "./footer";
import Kontact from "./kontakt";
import Debug from "./debug";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import "react-notifications/lib/notifications.css";

var getUrlParameter = name => {
  // eslint-disable-next-line
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(window.location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

class App extends Component {
  constructor() {
    super();
    this.state = {
      debug: getUrlParameter("termine") === "1"
    };

    const config = {
      onUpdate: this.onServiceWorkerUpdate.bind(this),
      onSuccess: this.onServiceWorkerSuccess.bind(this)
    };

    registerServiceWorker(config);
  }

  onServiceWorkerSuccess() {
    NotificationManager.success(
      "Diese Seite ist nun ohne Internet erreichbar!",
      "😮"
    );
  }

  onServiceWorkerUpdate() {
    NotificationManager.success("Bitte lade die Seite neu.", "🎁");
  }

  render() {
    return (
      <div>
        {this.state.debug ? (
          <Debug />
        ) : (
          <div className="App">
            <Header />
            <div className="content-wrapper">
              <Main />
              <Jugend />
              <Chronik />
              <Calendar />
              <Gallery />
              <Videogallery />
              <Freundvereine />
              <Kontact />
              <Impressum />
              <Footer />
            </div>
          </div>
        )}
        <NotificationContainer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js